import React from "react";
/** SplitLayout — sidebar + main content, used by Monitoring + Wizard templates. */
export default function SplitLayout({ side, children, testId }) {
  return (
    <div className="tpl-split" data-testid={testId || "tpl-split"}>
      <aside data-testid="tpl-split-side">{side}</aside>
      <main data-testid="tpl-split-main">{children}</main>
    </div>
  );
}
